import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.PEDIDO.DOTACAO_ORCAMENTARIA.BUSCAR_LISTAGEM_PAGINADA](context, idPedido) {
		const { data } = await api.dotacaoOrcamentariaApiClient.buscarListagemPaginada(idPedido)
		return data
	},
	async [actionTypes.PEDIDO.DOTACAO_ORCAMENTARIA.SETUP.BUSCAR_LISTAGEM_PAGINADA](
		context,
		{ idPedido, filtros, paginacao },
	) {
		const { data } = await api.setupDotacaoOrcamentariaPedidoApiClient.buscarListagemPaginada(
			idPedido,
			filtros,
			paginacao,
		)
		return data
	},
	async [actionTypes.PEDIDO.DOTACAO_ORCAMENTARIA.SETUP.BUSCAR_LISTAGEM_ORGAOS](contexto, idPedido) {
		const { data } = await api.setupDotacaoOrcamentariaPedidoApiClient.buscarListagemOrgaos(idPedido)
		return data
	},
	async [actionTypes.PEDIDO.DOTACAO_ORCAMENTARIA.SETUP.BUSCAR_LISTAGEM_EXERCICIOS]() {
		const { data } = await api.setupDotacaoOrcamentariaPedidoApiClient.buscarListagemExercicios()
		return data
	},
	async [actionTypes.PEDIDO.DOTACAO_ORCAMENTARIA.SETUP.BUSCAR_LISTAGEM_CLASSIFICACAO_DESPESAS](contexto, idPedido) {
		const { data } = await api.setupDotacaoOrcamentariaPedidoApiClient.buscarListagemClassificacaoDespesas(idPedido)
		return data
	},
	async [actionTypes.PEDIDO.DOTACAO_ORCAMENTARIA.CRIAR_DOTACAO](context, { idDotacao, itens }) {
		await api.dotacaoOrcamentariaApiClient.criarDotacao(idDotacao, itens)
	},
	async [actionTypes.PEDIDO.DOTACAO_ORCAMENTARIA.EDITAR_VALOR_DOTACAO](context, body) {
		const { data } = await api.dotacaoOrcamentariaApiClient.editarValorDotacao(body)
		return data
	},
	async [actionTypes.PEDIDO.DOTACAO_ORCAMENTARIA.EXCLUIR_DOTACAO](context, idDotacao) {
		await api.dotacaoOrcamentariaApiClient.excluirDotacao(idDotacao)
	},
}
